import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Icon, { Path } from '../base/Icon';
import type { BaseIconProps } from '../types';
const Safari: React.FC<BaseIconProps> = t0 => {
  const $ = _c(10);
  const {
    size: t1,
    width,
    height
  } = t0;
  const size = t1 === undefined ? 20 : t1;
  const iconWidth = width || size;
  const iconHeight = height || size;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Path d="M40,20A20,20,0,1,1,20,0,20,20,0,0,1,40,20Z" fill="#cfd8dc" />;
    t3 = <Path d="M37,20A17,17,0,1,1,20,3,17,17,0,0,1,37,20Z" fill="#448aff" />;
    t4 = <Path d="M17.9,17.9l4.2,4.2L31.3,8.7Z" fill="#ff3d00" />;
    t5 = <Path d="M20,20,31.3,8.7,22.1,22.1Z" fill="#bf360c" />;
    t6 = <Path d="M17.9,17.9,8.7,31.3l13.4-9.2Z" fill="#fff" />;
    t7 = <Path d="M20,20,8.7,31.3l13.4-9.2Z" fill="#bdbdbd" />;
    t8 = <Path d="M13.1,6.7a14.17,14.17,0,0,1,1.8-.8l1.2,2.7-1.8.8ZM32,21h2.9c0-.3.1-.7.1-1a3.4,3.4,0,0,0-.1-1H32ZM8.7,10.1l2.1,2.1,1.4-1.4L10.1,8.7ZM21,5.1A3.4,3.4,0,0,0,20,5a3.4,3.4,0,0,0-1,.1V8h2Zm5.4,1.4a10.66,10.66,0,0,0-1.9-.7L23.4,8.6l1.9.7ZM8.5,16.5l.7-1.9L6.5,13.5a10.66,10.66,0,0,0-.7,1.9ZM8,19H5.1A3.4,3.4,0,0,0,5,20a3.4,3.4,0,0,0,.1,1H8Zm23.5,4.5-.7,1.9,2.7,1.1a10.66,10.66,0,0,0,.7-1.9Zm2.6-8.6a14.17,14.17,0,0,0-.8-1.8l-2.7,1.2.8,1.8Zm-2.8,15-2.1-2.1-1.4,1.4,2.1,2.1ZM9.4,25.7l-.8-1.8L5.9,25.1a14.17,14.17,0,0,0,.8,1.8Zm16.3,4.9-1.8.8,1.2,2.7a14.17,14.17,0,0,0,1.8-.8Zm-9.2.9-1.9-.7-1.1,2.7a10.66,10.66,0,0,0,1.9.7ZM21,34.9V32H19v2.9c.3,0,.7.1,1,.1A3.4,3.4,0,0,0,21,34.9Z" fill="#bbdefb" />;
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
    t5 = $[3];
    t6 = $[4];
    t7 = $[5];
    t8 = $[6];
  }
  let t9;
  if ($[7] !== iconHeight || $[8] !== iconWidth) {
    t9 = <Icon width={iconWidth} height={iconHeight} viewBox="0 0 40 40" fill="none">{t2}{t3}{t4}{t5}{t6}{t7}{t8}</Icon>;
    $[7] = iconHeight;
    $[8] = iconWidth;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
};
export default Safari;